import {combineLatest, firstValueFrom, map, retry, shareReplay, switchMap} from 'rxjs';
import {loadJsEncrypt, loadCryptoJS} from '@/resource/js';
import {sd} from '@/da/sd';
import {browser$} from '@/streams/browser';
import {envUtil} from './env';

const loadJsEncrypt$ = browser$.pipe(
  switchMap(loadJsEncrypt),
  retry(3),
  shareReplay(1),
  map(() => (window as any).JSEncrypt)
);
const loadCryptoJS$ = browser$.pipe(
  switchMap(loadCryptoJS),
  retry(3),
  shareReplay(1),
  map(() => (window as any).CryptoJS)
);
/**
 * rsa验签
 */
export async function rsaVerify(params: RsaVerifyParam): Promise<boolean> {
  try {
    const {JSEncrypt, CryptoJS} = await firstValueFrom(combineLatest({JSEncrypt: loadJsEncrypt$, CryptoJS: loadCryptoJS$}));
    const {publicKey = getDefaultPublicKey(), data, signature} = params || {};
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    const verified = encrypt.verify(data, signature, CryptoJS.SHA256);
    return verified;
  } catch (error) {
    sd.track('rsa-verify-error', {message: error.message || 'unknow error'});
    return false;
  }
}

const publicKeys = {
  dev: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC++jQgqEk08Y9DHgRzauLozkx0fqEG7Nfcj1awEfAeA23MNxm+lv7w7C9ltUYn7R6ycACJJ9NwG2A67PcA51fWCkhaM1UroLWSA9OYTKGlEO/XDeKHc7yecwEvTGwTa5nv6kBhBHQjFjqxxJrdfKJO0I19yjIM5ATTpAEp/j5I7QIDAQAB',
  fat: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDBaK82/ZVAy67R1asa8yCKIyo5xaoD9FWt4kUj4znWYBR8+oiMCjWrNBrQBeLK8DnIakNMC8n75B6x8gUuWg+pPvzyTzDPPG4oCjEeVzh52fLH3AoJ+KmIHJzcjlEALQe/vDrPTky+Tl0gpQwU3vlrhj7pbd3MA0nGGYkL34sawwIDAQAB',
  prod: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDTXAUCEqm3pB7YCFXUNZuB2oyGTGDREA4qcQdtVUDGbmXUBLROOcOc7dKiY1FZgW0OdbYZ/EY3VOUc6sp94pfF60WTshdHqXRsAN4R2gVyT+S7Glj5W1h9iFntx4o4FYooNk0jzOn2pUsBNHEte9etT3ROIIvxPQVGqWtUKipRmwIDAQAB',
};
function getDefaultPublicKey() {
  if (envUtil.isLocal || location.hostname.indexOf('fat') === 0) {
    return publicKeys.fat;
  } else if (envUtil.isDev) {
    return publicKeys.dev;
  } else if (envUtil.isProduction || location.hostname.indexOf('ea') === 0) {
    return publicKeys.prod;
  }
}

interface RsaVerifyParam {
  data: string;
  signature: string;
  publicKey?: string;
}
